import React, { useState } from "react"
import { ModalContext } from "./ModalContext"

const ModalProvider = ({ children }) => {
  const [components, setComponents] = useState([])
  const [props, setProps] = useState([])

  const showModal = (component, componentProps = {}) => {
    setComponents(state => [...state, component])
    setProps(state => [...state, componentProps])
  }

  const hideModal = () => {
    setComponents(components.splice(1))
    setProps(props.splice(1))
  }

  return (
    <ModalContext.Provider
      value={{
        components,
        props,
        showModal,
        hideModal,
      }}
    >
      {children}
    </ModalContext.Provider>
  )
}

export { ModalProvider }
